import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "antd";
import { Features } from "src/components/featuresList";

const ActionsComponent = (props) => {
  const [screenActions, setScreenActions] = useState([]);
  const permissionsObj = useSelector(
    (state) => state.oidc?.user?.auth?.grantedPolicies
  );
  const findTabByName = (tabs, targetName) => {
    for (const tab of tabs) {
      if (tab.Name?.toLowerCase() === targetName?.toLowerCase()) {
        return tab; 
      }
      if (tab.isTabs?.length) {
        const found = findTabByName(tab.isTabs, targetName);
        if (found) return found;
      }
    }
    return null; 
  };
  const buildPermissionKey = (serviceName, actionName) => {
    if (props.targetTabName) {
      return `${serviceName}.${props.targetTabName}.${actionName}`;
    }
    return `${serviceName}.${actionName}`;
  };
  const updateActionsWithPermissions = (role, permissions) => {
    if (!role) return { actions: [] };

    const updatedRole = { ...role };
    updatedRole.isEnabled = Boolean(permissions?.[role.serviceName]);
    updatedRole.actions = (role.actions || []).map((action) => {
      const actionKey = buildPermissionKey(role.serviceName, action.Name);
      const isEnabled = Boolean(permissions?.[actionKey]);
      return { ...action, isEnabled };
    });

    if (role.isTabs?.length) {
      updatedRole.isTabs = role.isTabs.map((subTab) =>
        updateActionsWithPermissions(subTab, permissions)
      );
    }

    return updatedRole;
  };

  useEffect(() => {
    if (Features && props.serviceName && permissionsObj) {
      let targetTab = Features.find(
        (tab) =>
          tab.serviceName?.toLowerCase() === props.serviceName?.toLowerCase()
      );
      if (props.targetTabName && targetTab) {
        targetTab = findTabByName(targetTab?.isTabs || [], props.targetTabName);
      }

      if (targetTab) {
        const updatedRoleObject = updateActionsWithPermissions(
          targetTab,
          permissionsObj
        );
        setScreenActions(updatedRoleObject);
      } 
    }
  }, [Features, permissionsObj, props.serviceName, props.targetTabName]);

  const handleToolBarActions = (actionName) => {
    props.onActionClick(actionName);
  };

  return (
    <div className="flex justify-end gap-2">
      {screenActions?.actions?.map((action) =>
        action.isEnabled ? (
          <Tooltip key={action.Name} title={action.title}>
            <div
              className="cursor-pointer"
              onClick={() => handleToolBarActions(action.Name.toLowerCase())}
            >
              <span
                className={`icon lg ${action.icon.toLowerCase()}-icon cursor-pointer`}
              ></span>
            </div>
          </Tooltip>
        ) : null
      )}
    </div>
  );
};

export default ActionsComponent;
